<template>
  <div>
    <div class="d-flex flex-wrap align-center justify-space-between" style="gap: 16px;">
      <div class="d-flex flex-wrap align-center" style="gap: 16px;">
        <v-autocomplete style="width: 150px;" v-model="groupSearch" :items="searchGroupList" hide-no-data
          item-text="alias" item-value="id" :label="$t('find_group')"
          @change="refreshView(userSelected, $event, 'byGroup')" :rules="[validator.alfaNumberNotRequired]">
        </v-autocomplete>
        <v-autocomplete style="width: 150px;" v-model="userSelected" :items="users" hide-no-data item-text="full_name"
          item-value="id" :label="$t('find_user')" @change="refreshView($event, groupSearch, 'byUser')"
          :rules="[validator.alfaNumberNotRequired]"></v-autocomplete>
        <v-btn color="primary" @click="showUploadDialog">
          <img src="/img/upload.svg" class="mr-4">{{$t('upload_schedule')}}
        </v-btn>
      </div>

      <div class="d-flex align-center flex-wrap" style="gap: 16px;">
        <v-btn color="primary" outlined @click="goToday">{{ $t('calendar_today') }}</v-btn>
        <div class="d-flex align-center" style="gap: 16px;">
          <b>{{ justMonth() }}{{ monthAndYear() }}</b>
          <img @click="minusButton()" src="/img/arrow-left.png" class="attachment-images">
          <img @click="plusButton()" src="/img/arrow-right.png" class="attachment-images">
        </div>
      </div>
    </div>
    <v-data-table :loading="loading" :headers="headers" :items="thisWeekSchedule" class="elevation-1"
      :server-items-length="totalPage" :items-per-page="pageSize"
      :footer-props="{ 'items-per-page-options': [10, 50, 100, 500, 1000, 2000], 'items-per-page-text': $t('rows_per_page')  }"
      :page="page" disable-sort @update:page="getSchedule($event, pageSize)"
      @update:items-per-page="getSchedule(page, $event)" :no-data-text="$t('no_data')">

      <template v-slot:[`item.full_name`]="{ item }">
        <div style="display: flex; align-items: center; justify-items: center;">
          <div>
            <img v-if="item.avatar_url" :src="item.avatar_url" alt="Avatar" class="avatar" />
            <img v-else src="img/logo_initial_gradient.png" alt="Avatar" class="avatar" />
          </div>
          <div class="pa-4"
            style="display: flex; align-items: flex-start; justify-content: center; justify-items: start; flex-direction: column;">
            <p>{{ item.full_name}}
            </p>
            <span
              style="font-size: 12px; font-weight: 500; color: #686868; text-align: left;">{{ item.job_position}}</span>
          </div>
        </div>
      </template>
      <template v-slot:[`item.monday`]="{ item }">
        <div @click="changeSchedule(0, item)" class="my-3 cursor cursor pa-2"
          :class="checkCard(item.schedule_shifts[0], headers[1].text, monday)"
          style="display: flex; align-items: start; justify-items: start; justify-content: start; border-radius: 4px; border: 1px solid #828282; color: ##828282; text-align: left; !important;  height: 87px; width: 157px;">
          <div v-if="item.schedule_shifts[0] == undefined" style="display: flex; flex-direction: column;">
            <div>Empty</div>
          </div>
          <div v-else-if="item.schedule_shifts[0].shift_master === null" style="display: flex; flex-direction: column;">
            <div>Empty</div>
          </div>
          <div v-else-if="item.schedule_shifts[0].shift_master && item.schedule_shifts[0].shift_master.work_in"
            style="display: flex; flex-direction: column;">
            <b style="font-size: 14px;">{{item.schedule_shifts[0].shift_master.schedule_code}}</b>
            <span style="font-size: 12px;"
              :class="item.schedule_shifts[0].shift_master.description.length > 20 ? 'elipsis-text' : ''"><span>{{item.schedule_shifts[0].shift_master.description}}</span></span>
            <span style="font-size: 12px;" class="mt-3">{{item.schedule_shifts[0].shift_master.work_in.substring(0, 5)}}
              - {{item.schedule_shifts[0].shift_master.work_out.substring(0, 5)}}
              {{ getTimezone(item.schedule_shifts[0].shift_master.timezone) }}</span>
          </div>
          <div v-else-if="item.schedule_shifts[0].shift_master && item.schedule_shifts[0].shift_master.work_in === null"
            style="display: flex; flex-direction: column;">
            <b style="font-size: 14px;">{{item.schedule_shifts[0].shift_master.schedule_code}}</b>
            <span style="font-size: 12px;"
              :class="item.schedule_shifts[0].shift_master.description.length > 20 ? 'elipsis-text' : ''"><span>{{item.schedule_shifts[0].shift_master.description}}</span></span>
            <span style="font-size: 12px;" class="mt-3">Day Off</span>
          </div>

          <div v-else>Empty</div>
        </div>
      </template>
      <template v-slot:[`item.tuesday`]="{ item }">
        <div @click="changeSchedule(1, item)" class="my-3 cursor cursor pa-2"
          :class="checkCard(item.schedule_shifts[1], headers[2].text, tuesday)"
          style="display: flex; align-items: start; justify-items: start; justify-content: start; border-radius: 4px; border: 1px solid #828282; color: ##828282; text-align: left; !important;  height: 87px; width: 157px;">
          <div v-if="item.schedule_shifts[1] == undefined" style="display: flex; flex-direction: column;">
            <div>Empty</div>
          </div>
          <div v-else-if="item.schedule_shifts[1].shift_master === null" style="display: flex; flex-direction: column;">
            <div>Empty</div>
          </div>
          <div v-else-if="item.schedule_shifts[1].shift_master && item.schedule_shifts[1].shift_master.work_in"
            style="display: flex; flex-direction: column;">
            <b style="font-size: 14px;">{{item.schedule_shifts[1].shift_master.schedule_code}}</b>
            <span style="font-size: 12px;"
              :class="item.schedule_shifts[1].shift_master.description.length > 20 ? 'elipsis-text' : ''"><span>{{item.schedule_shifts[1].shift_master.description}}</span></span>
            <span style="font-size: 12px;" class="mt-3">{{item.schedule_shifts[1].shift_master.work_in.substring(0, 5)}}
              - {{item.schedule_shifts[1].shift_master.work_out.substring(0, 5)}}
              {{ getTimezone(item.schedule_shifts[1].shift_master.timezone) }}</span>
          </div>
          <div v-else-if="item.schedule_shifts[1].shift_master.work_in === null"
            style="display: flex; flex-direction: column;">
            <b style="font-size: 14px;">{{item.schedule_shifts[1].shift_master.schedule_code}}</b>
            <span style="font-size: 12px;"
              :class="item.schedule_shifts[1].shift_master.description.length > 20 ? 'elipsis-text' : ''"><span>{{item.schedule_shifts[1].shift_master.description}}</span></span>
            <span style="font-size: 12px;" class="mt-3">Day Off</span>
          </div>
          <div v-else>Empty</div>
        </div>
      </template>
      <template v-slot:[`item.wednesday`]="{ item }">
        <div @click="changeSchedule(2, item)" class="my-3 cursor cursor pa-2"
          :class="checkCard(item.schedule_shifts[2], headers[3].text, wednesday)"
          style="display: flex; align-items: start; justify-items: start; justify-content: start; border-radius: 4px; border: 1px solid #828282; color: ##828282; text-align: left; !important;  height: 87px; width: 157px;">
          <div v-if="item.schedule_shifts[2] == undefined" style="display: flex; flex-direction: column;">
            <div>Empty</div>
          </div>
          <div v-else-if="item.schedule_shifts[2].shift_master === null" style="display: flex; flex-direction: column;">
            <div>Empty</div>
          </div>
          <div v-else-if="item.schedule_shifts[2].shift_master && item.schedule_shifts[2].shift_master.work_in"
            style="display: flex; flex-direction: column;">
            <b style="font-size: 14px;">{{item.schedule_shifts[2].shift_master.schedule_code}}</b>
            <span style="font-size: 12px;"
              :class="item.schedule_shifts[2].shift_master.description.length > 20 ? 'elipsis-text' : ''"><span>{{item.schedule_shifts[2].shift_master.description}}</span></span>
            <span style="font-size: 12px;" class="mt-3">{{item.schedule_shifts[2].shift_master.work_in.substring(0, 5)}}
              - {{item.schedule_shifts[2].shift_master.work_out.substring(0, 5)}}
              {{ getTimezone(item.schedule_shifts[2].shift_master.timezone) }}</span>
          </div>
          <div v-else-if="item.schedule_shifts[2].shift_master.work_in === null"
            style="display: flex; flex-direction: column;">
            <b style="font-size: 14px;">{{item.schedule_shifts[2].shift_master.schedule_code}}</b>
            <span style="font-size: 12px;"
              :class="item.schedule_shifts[2].shift_master.description.length > 20 ? 'elipsis-text' : ''"><span>{{item.schedule_shifts[2].shift_master.description}}</span></span>
            <span style="font-size: 12px;" class="mt-3">Day Off</span>
          </div>

          <div v-else>Empty</div>
        </div>
      </template>
      <template v-slot:[`item.thursday`]="{ item }">
        <div @click="changeSchedule(3, item)" class="my-3 cursor cursor pa-2"
          :class="checkCard(item.schedule_shifts[3], headers[4].text, thursday)"
          style="display: flex; align-items: start; justify-items: start; justify-content: start; border-radius: 4px; border: 1px solid #828282; color: ##828282; text-align: left; !important;  height: 87px; width: 157px;">
          <div v-if="item.schedule_shifts[3] == undefined" style="display: flex; flex-direction: column;">
            <div>Empty</div>
          </div>
          <div v-else-if="item.schedule_shifts[3].shift_master === null" style="display: flex; flex-direction: column;">
            <div>Empty</div>
          </div>
          <div v-else-if="item.schedule_shifts[3].shift_master && item.schedule_shifts[3].shift_master.work_in"
            style="display: flex; flex-direction: column;">
            <b style="font-size: 14px;">{{item.schedule_shifts[3].shift_master.schedule_code}}</b>
            <span style="font-size: 12px;"
              :class="item.schedule_shifts[3].shift_master.description.length > 20 ? 'elipsis-text' : ''"><span>{{item.schedule_shifts[3].shift_master.description}}</span></span>
            <span style="font-size: 12px;" class="mt-3">{{item.schedule_shifts[3].shift_master.work_in.substring(0, 5)}}
              - {{item.schedule_shifts[3].shift_master.work_out.substring(0, 5)}}
              {{ getTimezone(item.schedule_shifts[3].shift_master.timezone) }}</span>
          </div>
          <div v-else-if="item.schedule_shifts[3].shift_master.work_in === null"
            style="display: flex; flex-direction: column;">
            <b style="font-size: 14px;">{{item.schedule_shifts[3].shift_master.schedule_code}}</b>
            <span style="font-size: 12px;"
              :class="item.schedule_shifts[3].shift_master.description.length > 20 ? 'elipsis-text' : ''"><span>{{item.schedule_shifts[3].shift_master.description}}</span></span>
            <span style="font-size: 12px;" class="mt-3">Day Off</span>
          </div>
          <div v-else>Empty</div>
        </div>
      </template>
      <template v-slot:[`item.friday`]="{ item }">
        <div @click="changeSchedule(4, item)" class="my-3 cursor cursor pa-2"
          :class="checkCard(item.schedule_shifts[4], headers[5].text, friday)"
          style="display: flex; align-items: start; justify-items: start; justify-content: start; border-radius: 4px; border: 1px solid #828282; color: ##828282; text-align: left; !important;  height: 87px; width: 157px;">
          <div v-if="item.schedule_shifts[4] == undefined" style="display: flex; flex-direction: column;">
            <div>Empty</div>
          </div>
          <div v-else-if="item.schedule_shifts[4].shift_master === null" style="display: flex; flex-direction: column;">
            <div>Empty</div>
          </div>
          <div v-else-if="item.schedule_shifts[4].shift_master && item.schedule_shifts[4].shift_master.work_in"
            style="display: flex; flex-direction: column;">
            <b style="font-size: 14px;">{{item.schedule_shifts[4].shift_master.schedule_code}}</b>
            <span style="font-size: 12px;"
              :class="item.schedule_shifts[4].shift_master.description.length > 20 ? 'elipsis-text' : ''"><span>{{item.schedule_shifts[4].shift_master.description}}</span></span>
            <span style="font-size: 12px;" class="mt-3">{{item.schedule_shifts[4].shift_master.work_in.substring(0, 5)}}
              - {{item.schedule_shifts[4].shift_master.work_out.substring(0, 5)}}
              {{ getTimezone(item.schedule_shifts[4].shift_master.timezone) }}</span>
          </div>
          <div v-else-if="item.schedule_shifts[4].shift_master.work_in === null"
            style="display: flex; flex-direction: column;">
            <b style="font-size: 14px;">{{item.schedule_shifts[4].shift_master.schedule_code}}</b>
            <span style="font-size: 12px;"
              :class="item.schedule_shifts[4].shift_master.description.length > 20 ? 'elipsis-text' : ''"><span>{{item.schedule_shifts[4].shift_master.description}}</span></span>
            <span style="font-size: 12px;" class="mt-3">Day Off</span>
          </div>
          <div v-else>Empty</div>
        </div>
      </template>
      <template v-slot:[`item.saturday`]="{ item }">
        <div @click="changeSchedule(5, item)" class="my-3 cursor cursor pa-2"
          :class="checkCard(item.schedule_shifts[5], headers[6].text, saturday)"
          style="display: flex; align-items: start; justify-items: start; justify-content: start; border-radius: 4px; border: 1px solid #828282; color: ##828282; text-align: left; !important;  height: 87px; width: 157px;">
          <div v-if="item.schedule_shifts[5] == undefined" style="display: flex; flex-direction: column;">
            <div>Empty</div>
          </div>
          <div v-else-if="item.schedule_shifts[5].shift_master === null" style="display: flex; flex-direction: column;">
            <div>Empty</div>
          </div>
          <div v-else-if="item.schedule_shifts[5].shift_master && item.schedule_shifts[5].shift_master.work_in"
            style="display: flex; flex-direction: column;">
            <b style="font-size: 14px;">{{item.schedule_shifts[5].shift_master.schedule_code}}</b>
            <span style="font-size: 12px;"
              :class="item.schedule_shifts[5].shift_master.description.length > 20 ? 'elipsis-text' : ''"><span>{{item.schedule_shifts[5].shift_master.description}}</span></span>
            <span style="font-size: 12px;" class="mt-3">{{item.schedule_shifts[5].shift_master.work_in.substring(0, 5)}}
              - {{item.schedule_shifts[5].shift_master.work_out.substring(0, 5)}}
              {{ getTimezone(item.schedule_shifts[5].shift_master.timezone) }}</span>
          </div>
          <div v-else-if="item.schedule_shifts[5].shift_master.work_in === null"
            style="display: flex; flex-direction: column;">
            <b style="font-size: 14px;">{{item.schedule_shifts[5].shift_master.schedule_code}}</b>
            <span style="font-size: 12px;"
              :class="item.schedule_shifts[5].shift_master.description.length > 20 ? 'elipsis-text' : ''"><span>{{item.schedule_shifts[5].shift_master.description}}</span></span>
            <span style="font-size: 12px;" class="mt-3">Day Off</span>
          </div>
          <div v-else>Empty</div>
        </div>
      </template>
      <template v-slot:[`item.sunday`]="{ item }">
        <div @click="changeSchedule(6, item)" class="my-3 cursor cursor pa-2"
          :class="checkCard(item.schedule_shifts[6], headers[7].text, sunday)"
          style="display: flex; align-items: start; justify-items: start; justify-content: start; border-radius: 4px; border: 1px solid #828282; color: ##828282; text-align: left; !important;  height: 87px; width: 157px;">
          <div v-if="item.schedule_shifts[6] == undefined" style="display: flex; flex-direction: column;">
            <div>Empty</div>
          </div>
          <div v-else-if="item.schedule_shifts[6].shift_master === null" style="display: flex; flex-direction: column;">
            <div>Empty</div>
          </div>
          <div v-else-if="item.schedule_shifts[6].shift_master && item.schedule_shifts[6].shift_master.work_in"
            style="display: flex; flex-direction: column;">
            <b style="font-size: 14px;">{{item.schedule_shifts[6].shift_master.schedule_code}}</b>
            <span style="font-size: 12px;"
              :class="item.schedule_shifts[6].shift_master.description.length > 20 ? 'elipsis-text' : ''"><span>{{item.schedule_shifts[6].shift_master.description}}</span></span>
            <span style="font-size: 12px;" class="mt-3">{{item.schedule_shifts[6].shift_master.work_in.substring(0, 5)}}
              - {{item.schedule_shifts[6].shift_master.work_out.substring(0, 5)}}
              {{ getTimezone(item.schedule_shifts[6].shift_master.timezone) }}</span>
          </div>
          <div v-else-if="item.schedule_shifts[6].shift_master.work_in === null"
            style="display: flex; flex-direction: column;">
            <b style="font-size: 14px;">{{item.schedule_shifts[6].shift_master.schedule_code}}</b>
            <span style="font-size: 12px;"
              :class="item.schedule_shifts[6].shift_master.description.length > 20 ? 'elipsis-text' : ''"><span>{{item.schedule_shifts[6].shift_master.description}}</span></span>
            <span style="font-size: 12px;" class="mt-3">Day Off</span>
          </div>
          <div v-else>Empty</div>
        </div>
      </template>
    </v-data-table>
    <v-dialog v-model="uploadDialog" max-width="680px">
      <v-form ref="form">
        <!-- Download Template -->
        <v-card class="pt-3">
          <v-card-title>
            <div class="row pb-0">
              <div class="col-10 pb-0">
                <span class="headline ml-2">Upload Schedule</span>
              </div>
              <div class="col-2 text-right pb-0">
                <v-btn icon right class="ml-auto" @click="uploadDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
              <div class="col-12 pb-0">
                <small class="ml-2 not-bold">Please do the step below :</small>
              </div>
              <div class="col-10 pb-0">
                <span class="headline ml-2">1. Download Schedule Template</span>
              </div>
            </div>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-autocomplete v-if="role != 3 || role === 3 && searchGroupList.length > 1"
                    v-model="uploadData.download.groupId" :items="searchGroupList" hide-no-data item-text="alias"
                    item-value="id" :label="$t('select_group')">
                  </v-autocomplete>
                </v-col>
                <v-col cols="6" sm="6">
                  <v-select v-model="uploadData.download.month" :items="monthList" hide-no-data item-text="name"
                    item-value="id" :label="$t('select_month')"></v-select>
                </v-col>
                <v-col cols="6" sm="6">
                  <v-select v-model="uploadData.download.year" :items="yearList" hide-no-data
                    :label="$t('select_year')"></v-select>
                </v-col>
                <v-row justify="end">
                  <v-col cols="4" class="mr-4">
                    <v-btn block color="primary" class="mt-3" @click="downloadSchedule()">Download Template</v-btn>
                  </v-col>
                </v-row>

              </v-row>
            </v-container>
          </v-card-text>

          <!-- Upload Template -->
          <v-card-title>
            <div class="row pb-0">
              <div class="col-12 pb-0">
                <span class="headline ml-2">2. Upload Filled Schedule</span>
              </div>
              <div class="col-12 pb-0">
                <p class="mx-4 not-bold" style="color: #1976D2; font-size: 16px; word-break: break-word;">Please upload
                  file according to the template (make sure the selected group is the same as downloaded one)</p>
              </div>
            </div>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-autocomplete v-if="role != 3 || role === 3 && searchGroupList.length > 1"
                    v-model="uploadData.upload.groupId" :items="searchGroupList" hide-no-data item-text="alias"
                    item-value="id" :label="$t('select_group')">
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-file-input v-model="uploadData.upload.file"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    :label="$t('template_file')"></v-file-input>
                </v-col>
                <v-row justify="end">
                  <v-col cols="6" v-if="uploadData.upload.loading">
                    <i style="color:#E64A4D !important;">Please do not close when uploading or you will start all over
                      again!</i>
                  </v-col>
                  <v-col cols="3" class="mr-10">

                    <v-btn :loading="uploadData.upload.loading" block color="primary" class="mt-3"
                      @click="uploadSchedule">Upload Schedule</v-btn>
                  </v-col>
                </v-row>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="changeDialog" max-width="800px">
      <v-card class="pa-6" v-if="popSchedule">
        <h3>{{ headers[dayClicked +1].text }}</h3>
        <v-row class="mt-4">
          <v-col>
            <div style="color: #686868; font-size: 12px;">
              {{$t('employee_name')}}
            </div>
            <div style="display: flex; align-items: center; justify-items: center;">
              <div>
                <img v-if="popSchedule.avatar_url" :src="popSchedule.avatar_url" alt="Avatar" class="avatar" />
                <img v-else src="img/logo_initial_gradient.png" alt="Avatar" class="avatar" />
              </div>
              <div class="pa-4"
                style="display: flex; align-items: flex-start; justify-content: center; justify-items: start; flex-direction: column;">
                <p>{{ popSchedule.full_name}}
                </p>
                <span
                  style="font-size: 12px; font-weight: 500; color: #686868; text-align: left;">{{ popSchedule.job_position}}</span>
              </div>
            </div>
          </v-col>
          <v-col>
            <div style="color: #686868; font-size: 12px;" class="mb-4">
              {{$t('shift_name')}}
            </div>
            <div v-if="checkUndefined(popSchedule.schedule_shifts[dayClicked])">
              <p> {{ popSchedule.schedule_shifts[dayClicked].shift_master.description }}</p>
            </div>
            <div v-else>
              <p>-</p>
            </div>
          </v-col>
          <v-col cols="12" style="position: relative;">
            <!-- PR WAIT -->
            <v-autocomplete check class="box-shadow-remove" solo
              :value="popSchedule.schedule_shifts[dayClicked].shift_master"
              :items="times" hide-no-data item-text="description" item-value="id" :label="$t('shift_name')"
              @change="saveTempSchedule($event)">
              <template v-slot:selection="{ item }">
                <v-row style="justify-content: space-between;">
                  <v-col md="6" style="width: 242px;" :style="item.work_in ? 'color: #1976D2;' : 'color: #E64A4D;'">
                    <span v-if="item.id">{{ item.schedule_code }} /</span> {{ item.description }} </v-col>
                  <v-col md="6" style="position: relative; width: 242px;">
                    <div style="position: absolute; right: -94px; top: 24px;">
                      <v-row :style="item.work_in ? 'color: #1976D2;' : 'color: #E64A4D;'" v-if="item.work_in">
                        <img src="/img/ontime.png" class="mr-4"> <span>{{item.work_in.substring(0, 5)}} -
                          {{item.work_out.substring(0, 5)}}
                          {{ getTimezone(item.timezone) }}</span>
                      </v-row>
                      <v-row :style="item.work_in ? 'color: #1976D2;' : 'color: #E64A4D;'" v-else>
                        <img v-if="item.id" src="/img/dayoff.png" class="mr-4"> <span v-if="item.id">Day Off</span>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </template>


              <template v-slot:item="{ item }">
                <v-row style="justify-content: space-between;">
                  <v-col md="6" :style="item.work_in ? 'color: #1976D2;' : 'color: #E64A4D;'"><span
                      v-if="item.id">{{ item.schedule_code }} /</span> {{ item.description }} </v-col>
                  <v-col md="6" style="position: relative;">
                    <div style="position: absolute; right: 32px; top: 30px;">
                      <v-row :style="item.work_in ? 'color: #1976D2;' : 'color: #E64A4D;'" v-if="item.work_in">
                        <img src="/img/ontime.png" style="height: 16px; width: 16px; margin-top: 2px;" class="mr-4">
                        <span style="line-height: 16px;">{{item.work_in.substring(0, 5)}} -
                          {{item.work_out.substring(0, 5)}}
                          {{ getTimezone(item.timezone) }}</span>
                      </v-row>
                      <v-row :style="item.work_in ? 'color: #1976D2;' : 'color: #E64A4D;'" v-else>
                        <img v-if="item.id" src="/img/dayoff.png" style="height: 16px; width: 16px; margin-top: 2px;"
                          class="mr-4"> <span v-if="item.id">Day Off</span>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>

              </template>
            </v-autocomplete>
            <!-- <v-autocomplete v-else class="box-shadow-remove" solo
            :value="null" :items="times" hide-no-data item-text="description" item-value="id" :label="$t('shift_name')"
              @change="saveTempSchedule($event)">
              <template v-slot:selection="{ item }">
                <v-row style="justify-content: space-between;">
                  <v-col md="6" style="width: 242px;" :style="item.work_in ? 'color: #1976D2;' : 'color: #E64A4D;'">
                    <span v-if="item.id">{{ item.schedule_code }} /</span> {{ item.description }} </v-col>
                  <v-col md="6" style="position: relative; width: 242px;">
                    <div style="position: absolute; right: -94px; top: 24px;">
                      <v-row :style="item.work_in ? 'color: #1976D2;' : 'color: #E64A4D;'" v-if="item.work_in">
                        <img src="/img/ontime.png" class="mr-4"> <span>{{item.work_in.substring(0, 5)}} -
                          {{item.work_out.substring(0, 5)}}
                          {{ getTimezone(item.timezone) }}</span>
                      </v-row>
                      <v-row :style="item.work_in ? 'color: #1976D2;' : 'color: #E64A4D;'" v-else>
                        <img v-if="item.id" src="/img/dayoff.png" class="mr-4"> <span v-if="item.id">Day Off</span>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </template>


              <template v-slot:item="{ item }">
                <v-row style="justify-content: space-between;">
                  <v-col md="6" :style="item.work_in ? 'color: #1976D2;' : 'color: #E64A4D;'"><span
                      v-if="item.id">{{ item.schedule_code }} /</span> {{ item.description }} </v-col>
                  <v-col md="6" style="position: relative;">
                    <div style="position: absolute; right: 32px; top: 30px;">
                      <v-row :style="item.work_in ? 'color: #1976D2;' : 'color: #E64A4D;'" v-if="item.work_in">
                        <img src="/img/ontime.png" style="height: 16px; width: 16px; margin-top: 2px;" class="mr-4">
                        <span style="line-height: 16px;">{{item.work_in.substring(0, 5)}} -
                          {{item.work_out.substring(0, 5)}}
                          {{ getTimezone(item.timezone) }}</span>
                      </v-row>
                      <v-row :style="item.work_in ? 'color: #1976D2;' : 'color: #E64A4D;'" v-else>
                        <img v-if="item.id" src="/img/dayoff.png" style="height: 16px; width: 16px; margin-top: 2px;"
                          class="mr-4"> <span v-if="item.id">Day Off</span>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>

              </template>
            </v-autocomplete> -->
          </v-col>
          <v-row justify="center" class="mb-4 mt-4">
            <v-btn color="primary" style="border: solid 1px #3277D5;" text @click="changeDialog = !changeDialog"
              class="mr-2">
              {{$t('cancel')}}</v-btn>
            <v-btn :loading="loading" color="primary" @click="saveSchedule(popSchedule)">{{$t('save')}}
            </v-btn>
            <!-- <v-btn v-else :loading="loading" color="primary" @click="insertSchedule(popSchedule)">{{$t('save')}}
            </v-btn> -->
          </v-row>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import moment from "moment";
  import readXlsxFile from 'read-excel-file'
  export default {
    name: "work",
    data() {
      return {
        searchGroupList: [],
        notif: {
          show: false,
          mode: '',
          text: [],
          title: '',
        },
        todayDate: moment().locale(this.$i18n.t('lang')).format('ddd DD-MMM'),
        today: moment(new Date).format('YYYY-MM-DD').valueOf(),
        monthList: [{
            id: 1,
            name: 'Januari'
          },
          {
            id: 2,
            name: 'Februari'
          },
          {
            id: 3,
            name: 'Maret'
          },
          {
            id: 4,
            name: 'April'
          },
          {
            id: 5,
            name: 'Mei'
          },
          {
            id: 6,
            name: 'Juni'
          },
          {
            id: 7,
            name: 'Juli'
          },
          {
            id: 8,
            name: 'Agustus'
          },
          {
            id: 9,
            name: 'September'
          },
          {
            id: 10,
            name: 'Oktober'
          },
          {
            id: 11,
            name: 'November'
          },
          {
            id: 12,
            name: 'Desember'
          },
        ],
        newDay: '',
        yearList: [
          2023,
          2024,
          2025,
          2026
        ],
        uploadData: {
          upload: {
            groupId: null,
            file: null,
            loading: false,
          },
          download: {
            groupId: null,
            month: null,
            year: null,
            loading: false,
          }
        },
        tempSchedule: null,
        uploadDialog: false,
        changeDialog: false,
        inProggress: true,
        downloadList: [''],
        groupSearch: null,
        groupList: [],
        role: this.$store.state.role,
        groupId: this.$store.state.group_id,
        userSelected: null,
        deleteLoading: false,
        bulkLoading: false,
        disableEdit: false,
        deleteDialog: false,
        loading: false,
        reset: false,
        isEdit: false,
        masterShift: [],
        times: [],
        dataItem: {
          id: '',
          name: '',
          date: '',
          shiftId: '',
          shiftDescription: '',
          shiftCode: '',
          shiftWorkIn: '',
          shiftWorkOut: '',
          shiftBreakIn: '',
          shiftBreakOut: '',
          scheduleId: '',
          patternName: '',
          day: null,
          tolerance: 0,
          interval: 0,
        },
        dialog: false,
        search: null,
        dataSchedule: [],
        date: {
          start: '',
          end: '',
          week: 0,
        },

        date_start: '',
        menu_start: '',
        menu_date: '',

        company_id: this.$store.state.company,
        validator: this.$store.state.validator,
        baseUrl: this.$store.state.baseUrl,
        users: [],
        patternByGroup: [],

        startDate: "",
        endDate: "",
        pageSize: 10,
        page: 1,
        monday: 1,
        tuesday: 2,
        wednesday: 3,
        thursday: 4,
        friday: 5,
        saturday: 6,
        sunday: 7,
        popSchedule: "",
        dayClicked: null,
        thisWeekSchedule: [],
        totalPage: null,
        headers: [{
            text: this.$i18n.t('employee_name'),
            value: "full_name"
          },
          {
            text: moment().day(1).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY'),
            value: "monday",
            align: "center"
          },
          {
            text: moment().day(2).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY'),
            value: "tuesday",
            align: "center"
          },
          {
            text: moment().day(3).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY'),
            value: "wednesday",
            align: "center"
          },
          {
            text: moment().day(4).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY'),
            value: "thursday",
            align: "center"
          },
          {
            text: moment().day(5).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY'),
            value: "friday",
            align: "center"
          },
          {
            text: moment().day(6).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY'),
            value: "saturday",
            align: "center"
          },
          {
            text: moment().day(7).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY'),
            value: "sunday",
            align: "center"
          },
        ],
      }
    },
    methods: {
      getTimezone(time) {
        switch (parseInt(time)) {
          case 7:
            return 'WIB'
          case 8:
            return 'WITA'
          case 9:
            return 'WIT'

          default:
            return time
        }
      },
      // tidyDate(date) {
      //   return moment(date).locale(this.$i18n.t('lang')).format('dddd, DD MMM YYYY')
      // },
      changeSchedule(day, item) {

        this.dayClicked = day
        this.popSchedule = item
        // eslint-disable-next-line no-console
        // console.log(item, 'this is item')
        const today = this.today;
        // this.newDay = moment(this.headers[day + 1].text).format('YYYY-MM-DD')
        this.newDay = moment(item.schedule_shifts[day].date).format('YYYY-MM-DD')
        // const cardDate = moment(this.headers[day + 1].text).format('YYYY-MM-DD').valueOf();
        const cardDate = moment(item.schedule_shifts[day].date).format('YYYY-MM-DD').valueOf();
        // eslint-disable-next-line no-console
        // console.log(item, cardDate, today, this.headers[day + 1].text)
        if (today > cardDate) {
          this.changeDialog = false
        } else {
          if (day, item) {
            this.changeDialog = true
          }
        }
      },
      checkCard(value, day, totalDays) {
        const today = this.today;
        const checkDate = moment().day(totalDays).format('YYYY-MM-DD')
        const cardDate = moment(checkDate).format('YYYY-MM-DD').valueOf();
        // // eslint-disable-next-line no-console
        // console.log(day)
        if (value == undefined || value.shift_master === null) {
          if (cardDate >= today) {
            return 'all-bit-grey'
          } else {
            return 'all-bar-grey'
          }
        } else {
          if (cardDate > today) {
            if (value.shift_master.work_in) {
              return 'border-bar-blue'
            } else {
              return 'holiday'
            }
          } else if (cardDate === today) {
            if (value.shift_master.work_in) {
              return 'all-bar-blue'
            } else {
              return 'holiday-today'
            }
          } else {
            return 'all-bar-grey'
          }
        }
      },
      justMonth() {
        if (this.startDate) {
          const start = moment(this.startDate, 'DD/MM/YYYY').format('MMM')
          const end = moment(this.endDate, 'DD/MM/YYYY').format('MMM')
          if (start === end) {
            return " "
          } else {
            return moment(this.startDate, 'DD/MM/YYYY').locale(this.$i18n.t('lang')).format('MMM') + " - "
          }
        } else {
          const start = moment().day(1).format('MMM')
          const end = moment().day(7).format('MMM')
          if (start === end) {
            return " "
          } else {
            return moment().day(1).locale(this.$i18n.t('lang')).format('MMM') + "-"
          }
        }
      },
      monthAndYear() {
        if (this.startDate) {
          return moment(this.endDate, 'DD/MM/YYYY').locale(this.$i18n.t('lang')).format('MMM YYYY')
        } else {
          return moment().day(7).locale(this.$i18n.t('lang')).format('MMM YYYY')
        }
      },
      async downloadSchedule() {
        const form = this.uploadData.download
        const userId = this.$store.state.user.id
        if (form.groupId) {
          const url =
            `${this.baseUrl}/schedule/download?month=${form.month}&year=${form.year}&groupId=${form.groupId}&userId=${userId}`
          window.open(url)
        } else {
          const url = `${this.baseUrl}/schedule/download?month=${form.month}&year=${form.year}&userId=${userId}`
          window.open(url)
        }
      },
      getHolidayClass(schedule, date) {
        if (schedule.work_in == null && schedule.work_out == null) {
          return 'mx-auto cursor ma-1 red-outline'
        } else {
          if (date == this.todayDate) {
            return 'mx-auto cursor ma-1 blue-outline'
          } else {
            return 'mx-auto cursor ma-1'
          }
        }
      },
      async uploadSchedule() {
        const baseGroup = this.groupList
        const groupAll = []
        if (this.uploadData.upload.groupId == null) {
          for (let i = 0; i <= baseGroup.length; i++) {
            if (baseGroup[i] != null && baseGroup[i].id != null) {
              groupAll.push(baseGroup[i].id)
            }
          }
        } else {
          groupAll.push(this.uploadData.upload.groupId)
        }
        if (this.uploadData.upload.file == null) return null
        this.uploadData.upload.loading = true
        const excelJson = await readXlsxFile(this.uploadData.upload.file)
        const body = {
          groupId: groupAll,
          data: excelJson
        }
        const result = await this.$store.dispatch('saveScheduleUploadV3', body)
        this.uploadData.upload.loading = false
        if (result) {
          this.showMessage('Berhasil Di upload', 'success')
          this.refreshView(this.userSelected, this.groupSearch)
        }
      },
      showUploadDialog() {

        this.uploadDialog = true
        if (this.role == 3) {
          const groupId = this.$store.state.user.detail.groupId
          this.uploadData.upload.groupId = groupId
          this.uploadData.download.groupId = groupId
        }

      },
      checkValue(item) {
        if (item === undefined) {
          return null
        } else {
          return item
        }
      },
      checkUndefined(item) {
        if (item === undefined) {
          return false
        } else if (item && item.shift_master) {
          return true
        }else{
          return false
        }
      },

      addItem() {
        this.isEdit = false
        this.reset = true
        this.dialog = true
        this.disableEdit = false
      },
      saveTempSchedule(data) {
        this.tempSchedule = data
      },
      cannotEditTodayAndPreviousSchedule(item) {
        const today = moment().format('YYYY-MM-DD')
        const isNotToday = moment(item.value, 'DD-MM-YYYY').diff(today, 'days')
        if (isNotToday > -1) {
          return false
        } else {
          this.showMessage('You can only edit shift data one day before the scheduled shift', 'warning')
          return true
        }
      },
      clickSchedule(data, item) {
        if (this.cannotEditTodayAndPreviousSchedule(item)) return null
        if (item.value == 'name') return null
        const user = this.users.find(e => {
          return e.id == data.id
        })
        const joinDate = moment(this.patternByGroup[user.groupId].activate_date, 'DD-MM-YYYY')
        const dateChoosen = moment(item.value, 'DD-MM-YYYY')
        const diffDays = dateChoosen.diff(joinDate, 'days')
        const scheduleNow = diffDays % this.patternByGroup[user.groupId].shift_days.length
        const pattern = this.getPatternForThatDate(user.groupId, scheduleNow)
        this.masterShift = pattern.pattern

        this.reset = false
        let Data = {
          id: data.id,
          name: data.name,
          date: moment(item.value, "DD-MM-YYYY").format("YYYY-MM-DD"),
        }
        const temp = data[item.value]
        if (temp) {
          this.isEdit = true
          this.disableEdit = true
          Data.scheduleId = temp.id
          if (temp.shift_master) {
            Data.shiftId = temp.shift_master.id
            Data.shiftDescription = temp.shift_master.description
            Data.shiftCode = temp.shift_master.schedule_code
            Data.shiftWorkIn = temp.shift_master.work_in
            Data.shiftWorkOut = temp.shift_master.work_out
            Data.shiftBreakIn = temp.shift_master.break_in
            Data.shiftBreakOut = temp.shift_master.break_out
          }
        } else {
          this.isEdit = false
          this.disableEdit = true
        }
        Data.patternName = pattern.name
        Data.day = pattern.day
        Data.tolerance = pattern.tolerance
        Data.interval = pattern.interval
        this.dataItem = Object.assign({}, Data)
        this.dialog = true
      },
      async onWeekChange(type) {
        if (!this.inProggress) {
          switch (type) {
            case 'next':
              this.date.week++
              break
            case 'prev':
              this.date.week--
              break
            default:
              this.date.week = moment().week()
              break
          }
          this.date = this.getDateByWeek(this.date.week)
          this.inProggress = true
          await this.refreshView(this.userSelected, this.groupSearch)
          await this.insertDataForWeek()
        } else {
          this.showMessage('Proccessing please wait.', 'info')
        }

        // this.masterShift = await this.getShiftMaster()
      },
      onDateChange() {
        this.menu_date = false
        this.getShiftMasterForDate()
      },
      changeUser() {
        this.getShiftMasterForDate()
      },
      getShiftMasterForDate() {
        if (this.dataItem.id && this.dataItem.date) {
          const user = this.users.find(e => {
            return e.id == this.dataItem.id
          })
          const joinDate = moment(this.patternByGroup[user.groupId].activate_date, 'DD-MM-YYYY')
          const dateChoosen = moment(this.dataItem.date, 'YYYY-MM-DD')
          const diffDays = dateChoosen.diff(joinDate, 'days')
          const scheduleNow = diffDays % this.patternByGroup[user.groupId].shift_days.length
          const pattern = this.getPatternForThatDate(user.groupId, scheduleNow)
          this.masterShift = pattern.pattern
          this.dataItem.patternName = pattern.name
          this.dataItem.day = pattern.day
          this.dataItem.tolerance = pattern.tolerance
          this.dataItem.interval = pattern.interval
        }
      },
      getDateByWeek(week) {
        if (!week) week = moment().week()
        const now = moment()
        const length = 7
        const date = [{
          text: this.$i18n.t('employee'),
          value: 'name'
        }]
        for (let i = 1; i <= length; i++) {
          date.push({
            text: now.clone().week(week).startOf('isoWeek').weekday(i).locale(this.$i18n.t('lang')).format(
              'ddd DD-MMM'),
            value: now.clone().week(week).startOf('isoWeek').weekday(i).format('DD-MM-YYYY')
          })
        }

        this.headers = date
        const start = now.clone().week(week).startOf('isoWeek').format('DD-MM-YYYY')
        return {
          start,
          end: moment(start, 'DD-MM-YYYY').add(6, 'days').format('DD-MM-YYYY'),
          week,
          date
        }
      },
      filterByRegisteredUser(data, isGroup = false) {
        const result = []
        if (data) {
          data.map(item => {
            if (item.id.length == 28 && item.is_shifted) {
              if (isGroup) {
                item.groupId = item.group_id
                item.full_name = item.fullname
              }
              result.push(item)
            }
          })
        }
        return result
      },
      async getUserList() {
        const result = await this.$store.dispatch('getEmployeeList', {
          companyId: this.company_id,
          pageSize: 2000,
          page: 0
        })
        let data = []
        if (result) {
          data = this.filterByRegisteredUser(result.rows)
        }
        return data
      },
      async saveSchedule(value) {
        // eslint-disable-next-line no-console
        // console.log(value)
        const data = {
          id: value.schedule_shifts[this.dayClicked].id,
          date: this.formatDate(value.schedule_shifts[this.dayClicked].date),
          userId: value.id,
          shiftMasterId: this.tempSchedule,
          tolerance: 0,
          interval: null
        }
        this.loading = true
        const result = await this.$store.dispatch('editScheduleWorkV3', data)
        this.loading = false
        if (result) {
          this.showMessage(this.$i18n.t('alert_edit'), 'success')
          this.getSchedule()
          this.changeDialog = false
        }
      },
      async insertSchedule(value) {
        // eslint-disable-next-line no-console
        // console.log(value)
        const data = {
          date: this.formatDate(this.newDay),
          userId: value.id,
          shiftMasterId: this.tempSchedule,
          tolerance: 0,
          interval: null
        }
        this.loading = true
        const result = await this.$store.dispatch('insertScheduleWorkV3', data)
        this.loading = false
        if (result) {
          this.showMessage(this.$i18n.t('alert_edit'), 'success')
          this.getSchedule()
          this.changeDialog = false
        }
      },
      async getDownloadList() {
        return new Promise(async (resolve) => {
          const groupId = this.groupSearch
          const month = moment(this.date.start, 'DD-MM-YYYY').format('MM')
          let url = `${this.baseUrl}/download/schedule?companyId=${this.company_id}&month=${month}`
          // let url = `${this.baseUrl}/scheduleshift/download?companyId=${this.company_id}&month=${month}`
          if (groupId) {
            url = `${url}&groupId=${groupId}`
          }
          window.open(url, '_blank')
          resolve()
        })
      },
      getDownloadTitle() {
        const companyName = this.$store.state.companyName
        const date = moment().format('MMM YYYY')
        return `Schedule ${companyName} - ${date}.xls`
      },
      async getUserListByGroupId(groupId) {
        const result = await this.$store.dispatch('getEmployeeListByGroup', {
          groupId,
          mobile: 0
        })
        let data = []
        if (result) {
          data = this.filterByRegisteredUser(result.team_member, true)
        }
        return data
      },
      async getScheduleByUser(item) {
        this.loading = true
        const result = await this.$store.dispatch('getScheduleShiftByUserV3', {
          userId: item,
          startDate: this.date.start,
          endDate: this.date.end
        })
        this.loading = false
        let data = []
        if (result) {
          data = result
        }
        return this.listDataSchedule(data)
      },
      async getScheduleByGroup(group) {
        this.loading = true
        const result = await this.$store.dispatch('getScheduleShiftByGroupV3', {
          groupId: group,
          startDate: this.date.start,
          endDate: this.date.end
        })
        this.loading = false
        return this.listDataSchedule(result)
      },
      async getSchedulePattern() {
        this.loading = true
        const result = await this.$store.dispatch('getShiftPatternByCompany', {
          companyId: this.company_id
        })
        this.loading = false
        return result
      },
      async getSchedulePatternByGroup(groupId) {
        this.loading = true
        const result = await this.$store.dispatch('getSchedulePatternByGroup', {
          groupId
        })
        this.loading = false
        return result
      },
      async getShiftMaster() {
        return await this.$store.dispatch('getScheduleShiftMasterByCompanyV3', {
          companyId: this.company_id,
          startDate: this.date.start,
          endDate: this.date.end
        })
      },
      async getGroupList() {
        const result = await this.$store.dispatch('getGroupByCompany', {
          companyId: this.company_id
        })
        let data = []
        if (result) {
          result.map(item => {
            if (item.is_shifted) data.push(item)
          })
          if (this.role != 3) {
            data.unshift({
              alias: this.$i18n.t('all'),
              id: null
            })
          }
        }
        return data
      },
      async getGroupListByHierarcy() {
        const result = await this.$store.dispatch('getGroupListById', {
          id: this.groupId
        })
        let data = []
        if (result) {
          result.map(item => {
            // if (item.is_shifted) {
            item.alias = item.name
            data.push(item)
            // }
          })
        }
        return data
      },
      async refreshView(item = null, group = null, searchBy = null) {
        switch (true) {
          case ((item != null) && (group == null)):
            await this.getDataByRole()
            await this.getSchedule()
            this.users.unshift({
              full_name: this.$i18n.t('all'),
              id: null
            })

            break
          case (item != null && group != null && searchBy == 'byUser'):
            await this.getSchedule()
            this.users = await this.getUserListByGroupId(group)
            this.users.unshift({
              full_name: this.$i18n.t('all'),
              id: null
            })

            break
          case (item != null && group != null && searchBy == 'byGroup'):
            await this.getSchedule()
            this.users = await this.getUserListByGroupId(group)
            this.users.unshift({
              full_name: this.$i18n.t('all'),
              id: null
            })
            this.userSelected = null

            break
          case (item == null && group != null):
            await this.getSchedule()
            this.users = await this.getUserListByGroupId(group)
            this.users.unshift({
              full_name: this.$i18n.t('all'),
              id: null
            })
            this.userSelected = null
            break
          case (item == null && group == null && searchBy == null):
          default:
            await this.getDataByRole()
            break
        }
      },
      mappingScheduleGroupAsFullSchedule() {
        const result = []
        return result
      },
      listDataSchedule(result) {
        const data = []
        result.map((item) => {
          if (data.length > 0) {
            const ind = data.findIndex(e => {
              return e.id == item.userId
            })
            if (ind >= 0) {
              data[ind] = Object.assign(data[ind], {
                [item.date]: item
              })
            } else {
              data.push({
                id: item.userId,
                name: item.user.full_name,
                [item.date]: item
              })
            }
          } else {
            data.push({
              id: item.userId,
              name: item.user.full_name,
              [item.date]: item
            })
          }
        })
        return data
      },
      mappingScheduleAsPerUserInTheGroup(data) {
        const result = []
        if (this.users) {
          this.users.map(user => {
            const schedule = data.find(e => {
              return e.id == user.id
            })
            if (schedule) {
              result.push(schedule)
            }
          })
        }
        return result
      },
      async insert(form) {
        if (!this.formValidation(form)) return null
        const data = [{
          date: this.formatDate(form.date),
          userId: form.id,
          shiftMasterId: form.shiftId,
          tolerance: form.tolerance,
          interval: form.interval
        }]
        this.loading = true
        const result = await this.$store.dispatch('saveScheduleWork', data)
        this.loading = false
        if (result) {
          this.showMessage(this.$i18n.t('alert_save'), 'success')
          this.refreshView(this.userSelected, this.groupSearch)
          this.dialog = false
        }
      },
      async insertBulk(bulkData) {
        this.bulkLoading = true
        const result = await this.$store.dispatch('saveScheduleWork', bulkData)
        this.bulkLoading = false
        if (result) {
          this.refreshView(this.userSelected, this.groupSearch)
        }
      },
      async update(form) {
        if (!this.formValidation(form)) return null
        const data = {
          id: form.scheduleId,
          date: this.formatDate(form.date),
          userId: form.id,
          shiftMasterId: form.shiftId,
          tolerance: form.tolerance,
          interval: form.interval
        }
        this.loading = true
        const result = await this.$store.dispatch('editScheduleWork', data)
        this.loading = false
        if (result) {
          this.showMessage(this.$i18n.t('alert_edit'), 'success')
          this.refreshView(this.userSelected, this.groupSearch)
          this.dialog = false
        }
      },
      async remove(form) {
        const data = {
          id: form.scheduleId
        }
        this.deleteLoading = true
        const result = await this.$store.dispatch('deleteScheduleWork', data)
        this.deleteLoading = false
        if (result) {
          this.showMessage(this.$i18n.t('alert_delete'), 'success')
          this.refreshView(this.userSelected, this.groupSearch)
          this.deleteDialog = false
          this.dialog = false
        }
      },

      showDeleteDialog() {
        this.deleteDialog = true
      },
      showMessage(msg, type) {
        this.$store.dispatch('nShowMessage', {
          type,
          msg
        })
      },
      showNotif(text, mode, title) {
        this.notif.text = text
        this.notif.mode = mode
        this.notif.title = title
        this.notif.show = true
      },
      formatDate(date) {
        return moment(date, "YYYY-MM-DD").format("DD-MM-YYYY")
      },
      sortingUserByGroup(users) {
        const data = {}
        users.map(user => {
          if (user.id != null) {
            if (!data[user.groupId]) {
              data[user.groupId] = []
            }

            data[user.groupId].push(user)
          }
        })
        return {
          data,
          key: Object.keys(data)
        }
      },
      async batchPatternByGroup(groupIds) {
        const query = []
        const data = {}
        groupIds.map(item => {
          query[item] = this.getSchedulePatternByGroup(item)
        })
        const array = await Promise.all(query)
        groupIds.map(item => {
          data[item] = array[item]
        })
        return data
      },
      async mappingDataForSend({
        data,
        key
      }, pattern, dates, scheduleExist) {
        const result = []
        const role = this.$store.state.role
        // const userLoginGroupId = this.$store.state.user.detail.groupId
        dates.shift()
        key.map(item => {
          if (pattern[item]) {
            if (pattern[item].shift_days) {
              if (pattern[item].shift_days.length > 0) {
                data[item].map(user => {
                  dates.map((date) => {
                    const joinDate = moment(pattern[item].activate_date, 'DD-MM-YYYY')
                    const dateChoosen = moment(date.value, 'DD-MM-YYYY')
                    const diffDays = dateChoosen.diff(joinDate, 'days')
                    if (diffDays >= 0) {
                      const scheduleNow = Math.abs(diffDays % pattern[item].shift_days.length)
                      const checkschedule = scheduleExist.find(e => {
                        return e.id == user.id
                      })
                      if (pattern[item].shift_days[scheduleNow]) {
                        const row = {
                          date: date.value,
                          userId: user.id,
                          shiftMasterId: pattern[item].shift_days[scheduleNow].shift_patterns.find(
                            e => {
                              return e.default == true
                            }).shiftMasterId,
                          tolerance: pattern[item].tolerance,
                          interval: pattern[item].interval,
                        }
                        if (user.status == 1 && user.is_shifted == true) {
                          if (this.groupSearch == null) {
                            if (checkschedule) {
                              if (!checkschedule[date.value]) {
                                if (role == 2 || role == 0 || role == 3) {
                                  result.push(row)
                                }
                              }
                            } else {
                              if (role == 2 || role == 0 || role == 3) {
                                result.push(row)
                              }
                            }
                          } else {
                            if (user.groupId == this.groupSearch) {
                              if (checkschedule) {
                                if (!checkschedule[date.value]) {
                                  if (role == 2 || role == 0 || role == 3) {
                                    result.push(row)
                                  }
                                }
                              } else {
                                if (role == 2 || role == 0 || role == 3) {
                                  result.push(row)
                                }
                              }
                            }
                          }
                        }

                      }
                    }
                  })
                })
              }
            }
          }
        })
        return result
      },

      async insertDataForWeek() {
        const user = this.userSelected ? [this.users.find(e => {
          return e.id == this.userSelected
        })] : this.users
        const userByGroup = this.sortingUserByGroup(user)
        // const patternByGroup = await this.mappingDataForPattern(userByGroup.key)
        const patternByGroup = await this.batchPatternByGroup(userByGroup.key)
        this.patternByGroup = Object.assign({}, patternByGroup)
        const result = await this.mappingDataForSend(userByGroup, patternByGroup, [].concat(this.date.date), this
          .dataSchedule)
        if (result.length > 0) {
          this.showMessage('Insert data schedule this week', 'success')
          await this.insertBulk(result)
        }
        this.inProggress = false
      },
      // async mappingDataForPattern(key) {
      //   const result = []
      //   const rawPattern = await this.getSchedulePattern()
      //   key.map(groupId => {
      //     const pattern = rawPattern.find(e => {return e.group_id == groupId})
      //     if (pattern) {
      //       result.push(pattern)
      //     }
      //   })
      //   return result
      // }

      getPatternForThatDate(groupId, scheduleNow) {
        let result = {
          name: '',
          pattern: [],
          day: 0
        }
        let data = this.patternByGroup[groupId].shift_days[scheduleNow]
        if (data) {
          const name = this.patternByGroup[groupId].schedule_name
          data.shift_patterns.map(item => {
            item.id = item.shiftMasterId
          })

          result.name = name
          result.pattern = data.shift_patterns
          result.day = data.day
          result.tolerance = this.patternByGroup[groupId].tolerance
          result.interval = this.patternByGroup[groupId].interval
        } else {
          this.showMessage('Schedule not found or before effective date start', 'warning')
        }
        return result
      },
      formValidation(form) {
        if (!form.id) return false
        if (!form.date) return false
        if (!form.shiftId) return false
        return true
      },
      async getDataByRole(getSchedule = true) {
        return new Promise(async (resolve) => {
          if (this.role == 2 || this.role == 0) {
            this.users = await this.getUserList()
            this.users.unshift({
              full_name: this.$i18n.t('all'),
              id: null
            })

            if (getSchedule) {
              this.dataSchedule = await this.getSchedule()
            }
            this.searchGroupList = this.groupList
            resolve(true)
          } else {
            const groupHierarcy = await this.getGroupListByHierarcy()
            const groupList = []
            this.users = []
            await Promise.all(groupHierarcy.map(async group => {
              groupList.push(group)
              const user = await this.getUserListByGroupId(group.id)
              await Promise.all(user.map(item => {
                this.users.push(item)
              }))
            }))
            this.searchGroupList = groupList
            this.groupSearch = `${this.groupId}`
            if (getSchedule) {
              const fullSchedule = await this.getSchedule()
              this.dataSchedule = this.mappingScheduleAsPerUserInTheGroup(fullSchedule)
            }
            resolve(true)
          }
        })
      },
      async getSchedule(page, pageSize) {
        this.loading = true
        if (page) {
          this.page = page
        } else {
          this.page = this.page
        }
        if (pageSize) {
          this.pageSize = pageSize
        } else {
          this.pageSize = this.pageSize
        }
        const result = await this.$store.dispatch('getNewSchedule', {
          companyId: this.company_id,
          startDate: this.startDate,
          endDate: this.endDate,
          pageSize: this.pageSize,
          page: this.page,
          groupId: this.groupSearch,
          userId: this.userSelected
        })
        if (result) {
          this.loading = false
          this.thisWeekSchedule = result.records
          this.totalPage = result.total
        }
        this.loading = false
      },
      plusButton() {
        this.monday = this.monday + 7
        this.tuesday = this.tuesday + 7
        this.wednesday = this.wednesday + 7
        this.thursday = this.thursday + 7
        this.friday = this.friday + 7
        this.saturday = this.saturday + 7
        this.sunday = this.sunday + 7
        this.headers[1].text = moment().day(this.monday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.headers[2].text = moment().day(this.tuesday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.headers[3].text = moment().day(this.wednesday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.headers[4].text = moment().day(this.thursday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.headers[5].text = moment().day(this.friday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.headers[6].text = moment().day(this.saturday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.headers[7].text = moment().day(this.sunday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.startDate = moment().day(this.monday).format('DD-MM-YYYY')
        this.endDate = moment().day(this.sunday).format('DD-MM-YYYY')
        this.getSchedule()
      },
      minusButton() {
        this.monday = this.monday - 7
        this.tuesday = this.tuesday - 7
        this.wednesday = this.wednesday - 7
        this.thursday = this.thursday - 7
        this.friday = this.friday - 7
        this.saturday = this.saturday - 7
        this.sunday = this.sunday - 7
        this.headers[1].text = moment().day(this.monday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.headers[2].text = moment().day(this.tuesday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.headers[3].text = moment().day(this.wednesday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.headers[4].text = moment().day(this.thursday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.headers[5].text = moment().day(this.friday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.headers[6].text = moment().day(this.saturday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.headers[7].text = moment().day(this.sunday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.startDate = moment().day(this.monday).format('DD-MM-YYYY')
        this.endDate = moment().day(this.sunday).format('DD-MM-YYYY')
        this.getSchedule()
      },
      goToday() {
        this.monday = 1
        this.tuesday = 2
        this.wednesday = 3
        this.thursday = 4
        this.friday = 5
        this.saturday = 6
        this.sunday = 7
        this.headers[1].text = moment().day(this.monday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.headers[2].text = moment().day(this.tuesday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.headers[3].text = moment().day(this.wednesday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.headers[4].text = moment().day(this.thursday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.headers[5].text = moment().day(this.friday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.headers[6].text = moment().day(this.saturday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.headers[7].text = moment().day(this.sunday).locale(this.$i18n.t('lang')).format('ddd, DD MMM YYYY')
        this.startDate = moment().day(this.monday).format('DD-MM-YYYY')
        this.endDate = moment().day(this.sunday).format('DD-MM-YYYY')
        this.getSchedule()
      },
      setAltImage(event) {
        event.target.src = 'img/neutral.png'
      },
      async getListTime() {
        const result = await this.$store.dispatch('getScheduleShiftMasterByCompanyV3', {
          companyId: this.company_id
        })
        // eslint-disable-next-line no-console
        // console.log(result)
        this.times = result;
        this.times.unshift({
          description: 'Empty',
          id: null
        })
        // eslint-disable-next-line no-console
        // console.log('times', this.times)
      },
    },
    async created() {
      if (this.role != 3) {
        this.groupList = await this.getGroupList()
      } else {
        this.groupList = await this.getGroupListByHierarcy()
      }
      this.searchGroupList = this.groupList
      // Get first data only the first group
      if (this.groupList.length > 1) {
        this.groupSearch = this.groupList[0].id
      }

      // Get data for all group deppend by role (set false to get only the user)
      await this.getDataByRole(false)
      this.startDate = moment().day(1).locale(this.$i18n.t('lang')).format('DD-MM-YYYY')
      this.endDate = moment().day(7).locale(this.$i18n.t('lang')).format('DD-MM-YYYY')
      this.getSchedule();
      this.getListTime();
    },

  }
</script>

<style>
  .elipsis-text {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 100px;
  }

  .elipsis-text:hover {
    overflow: visible;
  }

  .elipsis-text:hover span {
    position: relative;
    background-color: white;
    color: #1976D2;
    padding: 0 2px 0 2px;

    border: 1px solid #1976D2 !important;
  }
</style>

<style scoped>
  .border-bar-blue {
    background-color: white !important;
    border: 1px solid #1976D2 !important;
    color: #1976D2 !important;
  }

  .all-bar-blue {
    background-color: #1976D2 !important;
    border: 1px solid #1976D2 !important;
    color: white !important;
  }

  .all-bar-grey {
    background-color: #FFFFFF !important;
    border: 1px solid #CDCDCD !important;
    color: #CDCDCD !important;
  }

  .all-bit-grey {
    background-color: #FFFFFF !important;
    border: 1px solid #828282 !important;
    color: #828282 !important;
  }

  .holiday {
    background-color: #FCEDED !important;
    border: 1px solid #E64A4D !important;
    color: #E64A4D !important;
  }

  .holiday-today {
    background-color: #E64A4D !important;
    border: 1px solid #E64A4D !important;
    color: #FFFFFF !important;
  }

  .attachment-images:hover {
    cursor: pointer;
  }

  .avatar {
    vertical-align: middle;
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }

  .box-shadow-remove>>>.v-input__slot {
    border: #1976D2 1px solid !important;
    box-shadow: none !important;
    color: #1976D2;
  }

  .box-shadow-remove-blue>>>.v-input__slot {
    border: #1976D2 1px solid !important;
    box-shadow: none !important;
    color: #1976D2;
  }

  .box-shadow-remove-red>>>.v-input__slot {
    border: #E64A4D 1px solid !important;
    box-shadow: none !important;
    color: #E64A4D;
  }
</style>